"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function SttSnackbar(props) {
  return /*#__PURE__*/_react["default"].createElement(_core.Snackbar, props);
}
var _default = SttSnackbar;
exports["default"] = _default;